module.exports = __webpack_public_path__ + "static/media/announce.609053d3.png";